require('./bootstrap');

document.addEventListener("DOMContentLoaded", (event) => {

    if (document.querySelector('.navbar__search-icon')) {
        document.querySelector('.navbar__search-icon').addEventListener("click", () => {
            console.log('asd')
            document.querySelector('.navbar').classList.add('hide');
            document.querySelector('.search-form').classList.remove('hide');
        });
    }

    if (document.querySelector('.search-form')) {
        document.querySelector('.search-form input').addEventListener("keypress", (e) => {
            e.preventDefault;
            if (e.keyCode == 13) {
                console.log(document.querySelector('.search-form input').value);
                window.location.href = 'https://afriso.pl/wyszukiwanie?search=' + document.querySelector('.search-form input').value;

            }
        });
    }

    if (document.querySelector('.contact-us__form-submit')) {
        // document.querySelector('.contact-us__form-submit').addEventListener("click", () => {
        //     console.log('sent');
        //     fetch.
        //     // electronic_marketing_accept
        //     // recaptcha_response
        //     // _token
        //     // email
        //     // message
        // });
    }

    if (document.querySelector('#subscribe_form')) {
      const subscribeUrl = 'newsletter/subscribe';
      document.querySelector('#subscribe_form').addEventListener("submit", (e) => {
        e.preventDefault();
          console.log('sent');
          fetch(
            subscribeUrl, 
            {
              method: 'POST',
              body: JSON.stringify({
                _token: document.querySelector('.footer__form-input input[name = "_token"]').value,
                subscriber: document.querySelector('.footer__form-input input[name = "subscriber"]').value,
                recaptcha_response: document.querySelector('.footer__form-input input[name = "recaptcha_response"]').value,
              }),
              headers: {
                  'Content-Type': 'application/json'
              }
            }
          )
            .then(res => res.json())
            .then(res => {
              if (res.code == 1304) {
                console.log('user exists');
              }
              if (res.code == 200) {
                console.log('user subscribed');
              };
            });
      });
  }

    if (document.querySelector('.search-form__close')) {
        document.querySelector('.search-form__close').addEventListener("click", () => {
            document.querySelector('.navbar').classList.remove('hide');
            document.querySelector('.search-form').classList.add('hide');
        });
    }

    if (document.querySelector('#overlay-input')) {
        document.querySelector('#overlay-input').addEventListener("click", () => {
            if (document.querySelector('#overlay-input').checked) {
                document.querySelector('.mobile-menu').classList.remove('hide');
            } else {
                document.querySelector('.mobile-menu').classList.add('hide');
            }
        });
    }

    if (document.querySelector('#go_to-what_new'))  {
        document.querySelector('#go_to-what_new').addEventListener("click", () => {
            window.scroll({
                top: document.querySelector('.what-new').offsetTop - 100,
                behavior: "smooth",
            });
        });
    }

    if (document.querySelector('#go_to-video_tutorials')) {
        document.querySelector('#go_to-video_tutorials').addEventListener("click", () => {
            window.scroll({
                top: document.querySelector('.video-tutorials').offsetTop - 100,
                behavior: "smooth",
            });
        });
    }

    if (document.querySelector('#go_to-affiliate')) {
        document.querySelector('#go_to-affiliate').addEventListener("click", () => {
            window.scroll({
                top: document.querySelector('.affiliate').offsetTop - 100,
                behavior: "smooth",
            });
        });
    }

    if (document.querySelector('#go_to-contact_us')) {
        document.querySelector('#go_to-contact_us').addEventListener("click", () => {
            window.scroll({
                top: document.querySelector('.contact-us').offsetTop - 100,
                behavior: "smooth",
            });
        });
    }

    if (document.querySelector('.what-new__description')) {
      let newsIndex = 0;
      let allNews = document.querySelectorAll('.what-new__description');
      let allDots = document.querySelectorAll('.what-new__dot');
      
      const changeNews = () => {
        setTimeout(() => {
          allNews[newsIndex].classList.add('hide');
          allDots[newsIndex].classList.remove('what-new__dot-gray');
          allNews[newsIndex + 1 > 2 ? 0 : newsIndex + 1].classList.remove('hide');
          allDots[newsIndex + 1 > 2 ? 0 : newsIndex + 1].classList.add('what-new__dot-gray');
          newsIndex = newsIndex + 1 > 2 ? 0 : newsIndex + 1;
          changeNews();
        }, 5000);
      }
      changeNews();
    }



    (function() {

        var Modal = function() {
      
          var prefix = 'Modal-';
      
          this.Class = {
            stopOverflow: prefix + 'cancel-overflow',
            overlay: prefix + 'overlay',
            box: prefix + 'box',
            close: prefix + 'close'
          };
      
          this.Selector = {
            overlay: '.' + this.Class.overlay,
            box: '.' + this.Class.box,
            button: '[data-modal=button]'
          };
      
          this.Markup = {
            close: '<div class=" ' + this.Class.close + ' ">Close X</div>',
            overlay: '<div class=" ' + this.Class.overlay + ' "></div>',
            box: '<div class=" ' + this.Class.box + ' "></div>'
          }
      
          this.youtubeID = false;
      
        };
      
        Modal.prototype = {
      
          toggleOverflow: function() {
            $('body').toggleClass(this.Class.stopOverflow);
          },
      
          videoContainer: function() {
            return '<div class="video-container"><iframe id="player" src="https://www.youtube.com/embed/' + this.youtubeID + '?autoplay=1&rel=0" frameborder="0"></iframe></div>';
          },
      
          addOverlay: function() {
      
            var self = this;
      
            $(this.Markup.overlay).appendTo('body').fadeIn('slow', function() {
              self.toggleOverflow();
            });
      
            $(this.Selector.overlay).on('click touchstart', function() {
              self.closeModal();
            })
      
          },
      
          addModalBox: function() {
            $(this.Markup.box).appendTo(this.Selector.overlay);
          },
      
          buildModal: function(youtubeID) {
      
            this.addOverlay();
            this.addModalBox();
      
            $(this.Markup.close).appendTo(this.Selector.overlay);
            $(this.videoContainer(youtubeID)).appendTo(this.Selector.box);
      
          },
      
          closeModal: function() {
      
            this.toggleOverflow();
      
            $(this.Selector.overlay).fadeOut().detach();
            $(this.Selector.box).empty();
      
          },
      
          getYoutubeID: function() {
            return this.youtubeID;
          },
      
          setYoutubeID: function(href) {
      
            var id = '';
      
            if (href.indexOf('youtube.com') > -1) {
              // full Youtube link
              id = href.split('v=')[1];
            } else if (href.indexOf('youtu.be') > -1) {
              // shortened Youtube link
              id = href.split('.be/')[1];
            } else {
              // in case it's not a Youtube link, send them on their merry way
              document.location = href;
            }
      
            // If there's an ampersand, remove it and return what's left, otherwise return the ID
            this.youtubeID = (id.indexOf('&') != -1) ? id.substring(0, amp) : id;
      
          },
      
          startup: function(href) {
      
            this.setYoutubeID(href);
      
            if (this.youtubeID) {
              this.buildModal();
            }
      
          }
      
        };
      
        $(document).ready(function() {
      
          var modal = new Modal();
      
          $(modal.Selector.button).on('click touchstart', function(e) {
            e.preventDefault();
            modal.startup(this.href);
          });
      
        });
      
      })(this);
      
});